import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import auditReducer from '../features/audit_log/auditSlice';

export const store = configureStore({
  reducer: {
    audit: auditReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
